import React, { Component } from 'react';
import '../../css/SearchBar.css';
import { Debounce } from 'react-throttle';
import { withRouter } from 'react-router-dom'

class SearchBar extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  componentWillReceiveProps(newProps) {

    if (newProps.location.pathname.indexOf('/search/') === -1) {
      this.cleanSearch();
    }

    this.props = newProps;
  }

  componentDidMount() {
    let term = this.searchTerm();

    if (this.refs.searchValue && this.refs.searchValue !== term) {
      this.refs.searchValue.value = term;
    }
  }

  searchTerm() {
    if (this.props.location.pathname.indexOf('/search/') > -1) {
      return this.props.location.pathname.replace(/(\/search\/)(.*)/, '$2') || '';
    } else {
      return '';
    }
  }

  onChange(evt) {
    evt.preventDefault();
    let query = evt.target.value.trim();
    this.props.history.push(`/search/${query}`);
  }

  cleanSearch() {
    this.refs.searchValue.value = '';
  }

  render() {

    let searchPlaceHolder = 'Search for music, last.fm users and more'

    return (
      <div id="searchBar"> 
        <Debounce time="300" handler="onChange">
          <input type="text" ref="searchValue" onChange={this.onChange.bind(this)} autoFocus="true" className="searchBar" placeholder={searchPlaceHolder}/>
        </Debounce>
        
      </div>
    );
  }
}

export default withRouter(SearchBar);



// WEBPACK FOOTER //
// ./src/js/components/SearchBar.jsx